
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';

interface LineItemFormActionsProps {
  isLoading: boolean;
  isEditMode: boolean;
  onCancel: () => void;
}

const LineItemFormActions: React.FC<LineItemFormActionsProps> = ({
  isLoading,
  isEditMode,
  onCancel,
}) => {
  return (
    <div className="flex flex-col-reverse sm:flex-row justify-end gap-2">
      <Button
        type="button"
        variant="outline"
        onClick={onCancel}
        className="w-full sm:w-auto"
      >
        Cancel
      </Button>
      <Button 
        type="submit" 
        disabled={isLoading}
        className="w-full sm:w-auto"
      >
        {isLoading ? 'Saving...' : isEditMode ? 'Update' : 'Create'} Line Item
      </Button>
    </div>
  );
};

export default LineItemFormActions;
